import { Fragment, useEffect, useState } from "react";
import { Card, CardHeader, Col, Row, CardBody, Input, Button, Table, Modal, ModalBody, InputGroup, InputGroupAddon, InputGroupText, ModalHeader } from "reactstrap";
import { ThematicDto } from "../../../models/thematicDto";
import { translate } from "react-switch-lang";
import { useHttpClient } from "../../../security/hooks/axiosProvider";
import { toast } from "react-toastify";
import SweetAlert from "sweetalert2";
import styles from "./thematic.module.scss";
import AddSetting from "../add-setting/addSetting";
import { TypeSetting } from "../../../models/typeSetting";

function Thematique(props: any) {
  toast.configure();
  const httpClient = useHttpClient(true);
  const [thematic, setThematic] = useState<ThematicDto>(new ThematicDto());
  const [listThematic, setListThematic] = useState<ThematicDto[]>([]);
  const [listFiltredThematic, setListFiltredThematic] = useState<ThematicDto[]>([]);
  const [openModalEditSupport, setOpenModalEditSupport] = useState<boolean>(false);
  const [isOncreate, setIsOncreate] = useState<boolean>(true);

  const toggle = (data: ThematicDto) => {
    setOpenModalEditSupport(!openModalEditSupport);
    setThematic(data);
  };

  const handleDeleteThematic = (thematicId: any) => {
    SweetAlert.fire({
      title: props.t("thematic.message_confirmation_delete_thematic"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: String(props.t("button_delete")),
      cancelButtonText: String(props.t("button_cancel")),
      reverseButtons: true,
    }).then(result => {
      if (result.value) {
        httpClient.current?.delete("/thematic/" + thematicId).then(response => {
          if (response.data) {
            toast.success(String(props.t("message_toastr_delete")), {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 5000,
            });
            handleGetThematic();
          } else {
            toast.error(String(props.t("thematic.message_toastr_cannot_delete_thematic")), {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 5000,
            });
          }
        });
      } else {
      }
    });
  };

  const handleGetThematic = () => {
    httpClient.current?.get("/thematic").then(response => {
      setListThematic(response.data);
      setListFiltredThematic(response.data);
    });
  };

  useEffect(() => {
    httpClient.current?.get("/thematic").then(response => {
      setListThematic(response.data);
      setListFiltredThematic(response.data);
    });
  }, [httpClient]);

  const handleClickOnUpdate = (data: ThematicDto, index: number) => {
    setIsOncreate(false);
    toggle(data);
  };

  const handleSearch = (value: string) => {
    setListFiltredThematic(
      listThematic.filter(thematic => thematic.titleFrancais.toLocaleLowerCase().includes(value.toLocaleLowerCase()) || thematic.titleAnglais.toLocaleLowerCase().includes(value.toLocaleLowerCase())),
    );
  };

  return (
    <Fragment>
      <Card>
        <CardHeader className={styles["parametrage-card-header"]}>
          <Row>
            <Col md={12}>
              <div className={styles["parametrage-card-header-input"]}>
                <div className={styles["parametrage-card-inputs"]}>
                  <InputGroup className={styles["categories-search-input-group"]}>
                    <Input onChange={e => handleSearch(e.target.value)} type="search" placeholder={String(props.t("filters.input_placeholder_search"))} />
                    <InputGroupAddon addonType="append">
                      <InputGroupText className={styles["categories-search-input-group-text"]}>
                        <i className={"fa fa-search " + styles["categories-search-input-group-icon"]} />
                      </InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                </div>
                <Button
                  outline
                  color="success"
                  className={styles["categories-add-btn"]}
                  onClick={() => {
                    setIsOncreate(true);
                    toggle(new ThematicDto());
                  }}
                >
                  {props.t("thematic.button_add_thematic")}
                </Button>
              </div>
            </Col>
          </Row>
        </CardHeader>

        <CardBody className={styles["parametrage-card-body"]}>
          {listThematic.length === 0 ? (
            <div className="text-center">
              <div className={styles["no-data"]}>{props.t("thematic.message_no_thematic_title")} </div>
              <div className={styles["no-data"]}>{props.t("thematic.message_no_thematic_subtitle")}</div>
            </div>
          ) : (
            <Fragment>
              {
                <Table className={styles["parametrage-card-body"]}>
                  <thead>
                    <tr>
                      <th className={styles["document-table-nom"]} scope="col">
                        <span onClick={() => ""} className={styles["pointer"]}>
                          <i className={""}></i> {props.t("param_table_header.label_image")}
                        </span>
                      </th>
                      <th className={styles["document-table-thematique"]} scope="col">
                        {props.t("param_table_header.label_title_fr")}
                      </th>
                      <th className={styles["document-table-type"]} scope="col">
                        <span onClick={() => ""} className={styles["pointer"]}>
                          <i className={""}></i> {props.t("param_table_header.label_title_en")}
                        </span>
                      </th>

                      <th className={styles["document-table-actions"]} scope="col">
                        {props.t("param_table_header.actions")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {listFiltredThematic.map((data: ThematicDto, index: number) => (
                      <tr key={data.thematicId}>
                        <td>
                          <img className={styles["parametrage-card-image"]} src={data.urlImage + "/preview"} alt="" />
                        </td>
                        <td className="align-middle">{data.titleFrancais}</td>
                        <td className="align-middle">{data.titleAnglais}</td>

                        <td className={`${styles["document-table-actions-icons"]} align-middle`}>
                          <div>
                            <i className={`${styles["parametrage-actions__btn-update"]} fa fa-edit`} onClick={() => handleClickOnUpdate(data, index)} />
                            <i className={`${styles["parametrage-actions__btn-delete"]} fa fa-trash-o`} onClick={() => handleDeleteThematic(data.thematicId)} />
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              }
            </Fragment>
          )}
        </CardBody>
      </Card>
      <Modal isOpen={openModalEditSupport} size="lg">
        <ModalHeader toggle={() => toggle(new ThematicDto())}>{isOncreate ? props.t("thematic.title_create_thematic") : props.t("thematic.title_update_thematic")}</ModalHeader>
        <ModalBody>
          <AddSetting toggle={toggle} handleGet={handleGetThematic} type={TypeSetting.THEMATIC} settingModal={thematic}></AddSetting>
        </ModalBody>
      </Modal>
    </Fragment>
  );
}

export default translate(Thematique);
